// extracted by mini-css-extract-plugin
export default {"noWrap":"required_text-module___noWrap___a46050c6"};